<template>
  <div class="Container">
    <div class="Title">{{ title }}</div>
    <div class="Cta">
      <vv-button @click="$emit('click')">
        {{ $t('quiz.letsGo') }}
      </vv-button>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'

import { VvButton } from '@/components/common'

export default {
  name: 'DesktopMasterclassQuizButton',
  components: { VvButton },
  props: {
    masterclassId: {
      type: String,
      required: true
    }
  },
  computed: {
    masterclass() {
      return get(this.$store, ['state', 'lesson', 'theme', 'byId', this.masterclassId], null)
    },
    title() {
      const label = get(this.masterclass, 'desktopQuizLabel', null)

      if (label) return label

      const masterclassTitle = get(this.masterclass, 'title', null)
      const quizLabel = this.$t('theme.quizButton')

      return masterclassTitle ? `${masterclassTitle} : ${quizLabel}` : quizLabel
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.Container {
  margin-top: 20px;
  padding: 20px 25px;
  box-sizing: border-box;
  border: 2px solid $primary;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .Title {
    font-size: 16px;
    font-weight: bold;
    color: $primary;
  }
}
</style>
